import { Component } from '@angular/core';

@Component({
    selector: 'ion-wrapper',
    styles: [require('./ion-wrapper.scss')],
    template: require('./ion-wrapper.html')
})
export class IonWrapperComponent {

    private message: string;

    constructor() {
        console.log('Hello StopWatchWrapperComponent Component');
    }

    public handleMessageEvent(ev: any) {
        this.message = ev.detail;
        console.log('Received event from StopWatch component: ', this.message);
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/ion-wrapper/ion-wrapper.ts